import { Spin } from 'antd'
import Financials from '../Financials/Financials'
import { DashboardFilters } from '../Dashboard/dashboardModel'
import { useFinancialsData } from '../Dashboard/dashboardQueries'

export type Props = {
  starting: string
  ending: string
  filters: DashboardFilters
}
export default function FilteredFinancialsSection({ starting, ending, filters }: Props) {
  const financialsQuery = useFinancialsData(starting, ending, filters)
  const isMissingRange = !starting || !ending

  return (
    <div className="financials-section">
      {isMissingRange && <div className="financials">
        <div className="title">
          <h1>Company-wide Job Costing</h1>
          <p>Please select a time range at the top of the page.</p>
        </div>
      </div>}
      {financialsQuery.isError && <div className="financials">
        <div className="title">
          <h1>Company-wide Job Costing</h1>
          <p>Error loading data</p>
        </div>
      </div>}
      {!isMissingRange && !financialsQuery.isError && <Spin spinning={financialsQuery.isFetching}>
        <Financials title="Company-wide Job Costing" data={financialsQuery.data} renderFilters={() => null} displayLaborHours={true} displayJobs />
      </Spin>}
    </div>
  );
}
